import { Globe, Smartphone, Bitcoin, Star, TrendingUp, CheckCircle } from "lucide-react";

const categories = [
  {
    icon: Star,
    title: "Nové online casino CZ",
    text: "Nové platformy přitahují svěžím designem, moderním rozhraním a zejména štědrými bonusy pro nováčky na stránce. Pravidelně testujeme nové české i mezinárodní platformy.",
  },
  {
    icon: Globe,
    title: "Zahraniční kasina",
    text: "Mnoho zahraničních kasin přijímá hráče z Česka. Liší se štědřejšími bonusy, rozšířenou nabídkou her a podporou různých měn.",
  },
  {
    icon: Smartphone,
    title: "Nejlepší kasinové aplikace",
    text: "Nejlepší aplikace nabízí rychlé načítání, intuitivní rozhraní a široký výběr her. Verze pro iOS i Android.",
  },
  {
    icon: Bitcoin,
    title: "Nejlepší krypto kasina",
    text: "Kryptoměnová kasina podporují BTC, ETH a další tokeny pro bezpečné a decentralizované transakce.",
  },
];

const highlights = [
  "Tisíce her od slotů po live casino",
  "Licencované platformy dodržují zákonné požadavky",
  "Široký výběr platebních metod včetně kryptoměn",
  "Optimalizace pro mobilní zařízení",
];

export function EditorialSection() {
  return (
    <section className="py-16 bg-gray-50" data-testid="section-editorial">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16">
        <div className="grid lg:grid-cols-2 gap-14">
          <div>
            <h2 className="text-3xl font-black text-gray-900 mb-5">CZ Online Kasina</h2>
            <p className="text-gray-600 leading-relaxed mb-6">
              V posledních letech získalo casino online v Česku zvláštní popularitu a stalo se jedním z nejžádanějších druhů digitální zábavy. Stále více hráčů dává přednost právě online formátu.
            </p>

            <div
              className="p-4 rounded-xl border-l-4 border-[#003da5] mb-6"
              style={{ background: "linear-gradient(135deg, #f0f5ff 0%, #e8f0fe 100%)" }}
              data-testid="editorial-callout"
            >
              <p className="text-gray-700 text-sm font-semibold italic leading-relaxed">
                „Uživatelé mohou získat přístup k tisícům hazardních her z počítače nebo chytrého telefonu – kdykoli a odkudkoli."
              </p>
            </div>

            <div className="space-y-2.5 mb-6">
              {highlights.map((item, i) => (
                <div key={i} className="flex items-start gap-2.5" data-testid={`editorial-highlight-${i}`}>
                  <CheckCircle className="w-4 h-4 text-[#003da5] flex-shrink-0 mt-0.5" />
                  <span className="text-gray-600 text-sm leading-relaxed">{item}</span>
                </div>
              ))}
            </div>

            <h3 className="text-2xl font-black text-gray-900 mb-4">Prozkoumejte best casino online možnosti</h3>
            <p className="text-gray-600 leading-relaxed">
              Čeští hráči mají k dispozici široký výběr online kasin. Od novinek s pokročilými technologiemi až po zahraniční platformy s bohatou nabídkou her – každý si najde vhodný formát.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 gap-5">
            {categories.map((cat, i) => (
              <div
                key={i}
                className="p-5 rounded-xl bg-white border border-gray-100 hover-elevate cursor-default"
                data-testid={`editorial-cat-${i}`}
              >
                <div className="w-10 h-10 rounded-xl bg-[#003da5]/8 flex items-center justify-center mb-3">
                  <cat.icon className="w-5 h-5 text-[#003da5]" />
                </div>
                <h4 className="font-bold text-gray-900 text-sm mb-2">{cat.title}</h4>
                <p className="text-gray-500 text-xs leading-relaxed">{cat.text}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 grid lg:grid-cols-2 gap-8">
          <div
            className="p-6 rounded-xl border border-[#003da5]/15"
            style={{ background: "linear-gradient(135deg, #f0f5ff 0%, #e8f0fe 100%)" }}
          >
            <div className="flex items-center gap-2 mb-3">
              <TrendingUp className="w-5 h-5 text-[#003da5]" />
              <h3 className="text-xl font-black text-gray-900">
                Naše žebříčky a hodnocení
              </h3>
            </div>
            <p className="text-gray-600 text-sm leading-relaxed mb-3">
              Sestavujeme hodnocení na základě nejdůležitějších kritérií: bezpečnost, pohodlí, bonusy, výběr her a kvalita zákaznické podpory.
            </p>
            <p className="text-gray-600 text-sm leading-relaxed">
              Bereme v úvahu recenze skutečných hráčů a pravidelně aktualizujeme údaje, abychom doporučovali pouze ta kasina, která si skutečně zaslouží důvěru.
            </p>
          </div>

          <div className="p-6 rounded-xl bg-white border border-gray-100">
            <div className="flex items-center gap-2 mb-3">
              <Star className="w-5 h-5 text-[#003da5]" />
              <h3 className="text-xl font-black text-gray-900">
                Výhody pro hráče
              </h3>
            </div>
            <p className="text-gray-600 text-sm leading-relaxed mb-3">
              Doporučujeme věnovat pozornost ověřeným webům s vysokým hodnocením a vynikající reputací. Právě taková kasina najdete v našem žebříčku.
            </p>
            <p className="text-gray-600 text-sm leading-relaxed">
              Každá z uvedených platforem nabízí zajímavé bonusy, široký výběr her, podporu kryptoměn a optimalizaci pro mobilní zařízení.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
